export const BASE_API = 'https://api.airtable.com/v0'
export const BASE_ID_USER = process.env.REACT_APP_AIRTABLE_BASE_ID_USER
export const API_KEY = process.env.REACT_APP_AIRTABLE_API_KEY
export const INVESTORS_TABLE = process.env.REACT_APP_AIRTABLE_TABLE_NAME_INVESTOR
export const COMPANIES_TABLE = process.env.REACT_APP_AIRTABLE_TABLE_NAME_COMPANIES
export const FOUNDER_TABLE = process.env.REACT_APP_AIRTABLE_TABLE_NAME_FOUNDER
